import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SubjectVisualizerDialogComponent } from '../subject-visualizer-dialog/subject-visualizer-dialog.component';
import { Subject } from 'app/shared/models/subject';
import { ELVisData, SubjectVisualizerService } from 'app/shared/services/subject-visualizer.service';

@Component({
  selector: 'app-visualize',
  templateUrl: './visualize.component.html',
  styleUrls: ['./visualize.component.scss']
})
export class VisualizeComponent implements OnInit {

  public text: string = "";
  public visData: ELVisData = null;
  public _subject: Subject = null;

  @Input() backgroundColor;
  @Input() set subject(val: Subject) {
    this._subject = val;
    this.text = " Visualise Links ";
    
    if (this._subject) {
      this.subjectVis.getSubjectVizData(this._subject.id).subscribe(
        (res: ELVisData) => {
          if (res) {
            this.visData = res;
            this.text = " Visualise Links " + String(res.numberOfSubjects | 0) + "/" + String(res.maxDepth | 0);
          }
        }
      );
    }
  }

  constructor(private subjectVis: SubjectVisualizerService,
    private dialog: MatDialog) { }

  ngOnInit() {
  }

  showVisualize() {
    // Show Popup screen
    this.subjectVis.getSubjectVizData(this._subject.id).subscribe(
      (res: ELVisData) => {
        if (res) {
          this.visData = res;

          this.dialog.open(SubjectVisualizerDialogComponent, {
            data: {
              subject: this._subject,
              vizData: this.visData,
            },
          });          
        }
      }
    );    
  }
}
